import { KPMGMessage } from "./KPMGMessage";

export const messageBlockConfig = {
  "kpmg-germany": KPMGMessage,
};
